import { render, staticRenderFns } from "./form-lab-job.vue?vue&type=template&id=261d41e0&"
import script from "./form-lab-job.vue?vue&type=script&lang=js&"
export * from "./form-lab-job.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports